import axios from "../../../core/api/http-common";

const ON_COURSES_CREATE = "/schools/streams/courses/create";
// const ON_COURSES_GET_ALL = "/courses/get";
const ON_COURSES_GET_WITH_PAGINATION =
  "/schools/streams/courses/get/with/pagination";
const ON_COURSES_GET_RELEASED = "/schools/streams/courses/get/release";
const ON_COURSES_GET_ARCHIVED = "/schools/streams/courses/get/archive";

// export function onGetCourses(axiosPrivate, signal) {
//   return new Promise(async (resolve, reject) => {
//     await axiosPrivate
//       .get(ON_COURSES_GET_ALL, {
//         signal: signal,
//       })
//       .then((response) => {
//         resolve(response);
//       })
//       .catch((error) => {
//         reject(error);
//       });
//   });
// }
export function onGetCoursesWithPaginationByStreamId(axiosPrivate, _data, signal) {
  const data = {
    stream_id: _data?.stream_id,
    rows_per_page: _data?.rows_per_page,
    current_page: _data?.current_page,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate.get(ON_COURSES_GET_WITH_PAGINATION, {
        params: data,
        signal: signal,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function onCreateCourse(axiosPrivate, data) {
  const _data = {
    stream_id: data?.classes_id,
    language: data?.language,
    title: data?.title,
    description: data?.description,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate.post(ON_COURSES_CREATE, _data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function onGetCoursesReleased(axiosPrivate, is_action, selectedRows, updated_at) {
  const _data = {
    is_action: is_action, // "activate" or "desactivate"
    selected_rows: selectedRows,
    updated_at: updated_at,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate.patch(ON_COURSES_GET_RELEASED, _data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function onGetCoursesArchived(axiosPrivate, is_action, selectedRows, updated_at) {
  const _data = {
    is_action: is_action, // "activate" or "desactivate"
    selected_rows: selectedRows,
    updated_at: updated_at,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate.patch(ON_COURSES_GET_ARCHIVED, _data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// Chapters
//
const ON_CHAPTER_CREATE = "/schools/streams/courses/chapters/create";
const ON_CHAPTERS_GET_ALL = "/schools/streams/courses/chapters/get";
const ON_CHAPTERS_RELEASED = "/schools/streams/courses/chapters/release";
const ON_CHAPTERS_ARCHIVED = "/schools/streams/courses/chapters/archive";

export function onCreateChapter(axiosPrivate, data) {
  const _data = {
    course_id: data?.course_id,
    language: data?.language,
    title: data?.title,
    description: data?.description,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate.post(ON_CHAPTER_CREATE, _data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function onGetChaptersByCourseId(axiosPrivate, _data, signal) {
  const data = {
    course_id: _data?.course_id,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate.get(ON_CHAPTERS_GET_ALL, {
        params: data,
        signal: signal,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function onGetChaptersReleased(axiosPrivate, is_action, chapter_id, updated_at) {
  const _data = {
    is_action: is_action, // "activate" or "desactivate"
    chapter_id: chapter_id,
    updated_at: updated_at,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate.patch(ON_CHAPTERS_RELEASED, _data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function onGetChaptersArchived(axiosPrivate, is_action, chapter_id, updated_at) {
  const _data = {
    is_action: is_action, // "activate" or "desactivate"
    chapter_id: chapter_id,
    updated_at: updated_at,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate.patch(ON_CHAPTERS_ARCHIVED, _data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
//
// Lessons
const ON_LESSON_CREATE = "/schools/streams/courses/chapters/lessons/create";
const ON_LESSONS_RELEASED = "/schools/streams/courses/chapters/lessons/release";
const ON_LESSONS_ARCHIVED = "/schools/streams/courses/chapters/lessons/archive";
//
export function onCreateLesson(axiosPrivate, data) {
  return new Promise(async (resolve, reject) => {
    await axiosPrivate.post(ON_LESSON_CREATE, data, {
        withCredentials: true,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function onGetLessonsReleased(axiosPrivate, is_action, lesson_id, updated_at) {
  const _data = {
    is_action: is_action, // "activate" or "desactivate"
    lesson_id: lesson_id,
    updated_at: updated_at,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate.patch(ON_LESSONS_RELEASED, _data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function onGetLessonsArchived(axiosPrivate, is_action, lesson_id, updated_at) {
  const _data = {
    is_action: is_action, // "activate" or "desactivate"
    lesson_id: lesson_id,
    updated_at: updated_at,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate.patch(ON_LESSONS_ARCHIVED, _data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
//
// Lesson Questions
const ON_LESSON_QUESTIONS =
  "/schools/streams/courses/chapters/lessons/get/questions/set/with/pagination";
const ON_LESSON_QUESTIONS_SET_CREATION =
  "/schools/streams/courses/chapters/lessons/create/questions/set";
const ON_RELEASE_LESSON_QUESTIONS =
  "/schools/streams/courses/chapters/lessons/release/questions/set";
const ON_ARCHIVE_LESSON_QUESTIONS =
  "/schools/streams/courses/chapters/lessons/archive/questions/set";
//
export function onGetLessonQuestionsSetByLesonId(axiosPrivate, data, signal) {
  const _data = {
    lesson_id: data?.lesson_id,
    rows_per_page: data?.rows_per_page,
    current_page: data?.current_page,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate.get(ON_LESSON_QUESTIONS, {
        params: _data,
        signal: signal,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function onCreateLessonQuestions(axiosPrivate, data) {
  return new Promise(async (resolve, reject) => {
    await axiosPrivate.post(ON_LESSON_QUESTIONS_SET_CREATION, data, {
        withCredentials: true,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function onReleaseLessonQuestions(axiosPrivate,
  lesson_question_id,
  is_activated,
  dates,
) {
  const _data = {
    is_activated: is_activated,
    lesson_question_id: lesson_question_id,
    is_activated: is_activated,
    updated_at: dates,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate.patch(ON_RELEASE_LESSON_QUESTIONS, _data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function onArchiveLessonQuestions(
  axiosPrivate,
  lesson_question_id,
  is_deleted,
  dates,
) {
  const _data = {
    lesson_question_id: lesson_question_id,
    is_deleted: is_deleted,
    updated_at: dates,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate.patch(ON_ARCHIVE_LESSON_QUESTIONS, _data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
